import axios from 'axios'
import config from '@/config'

function getApiHost() {
  switch(process.env.NODE_ENV) {
    case 'development' : return config.baseURL;
    default : return `${location.protocol}//${location.host.replace(/^[^\\.]*\./, 'api.')}/v1`;
  }
}

const baseUrl = getApiHost();
const http = axios.create({
  baseURL: baseUrl,
  timeout: 10000000,
});

http.defaults.headers.get['Content-Type'] = 'application/json'
http.defaults.headers.post['Content-Type'] = 'application/json'

http.interceptors.response.use((response) => response.data, error => Promise.reject(error.response || { status: 500, data: error.message }));
if(location.hostname == 'localhost') { window['http'] = http; }

const auth = {
  // default
  login: (m) => { return http.post('auth/partner/login', m); },
  profile: (m) => { return http.post('auth/partner/profile/get', m); },
  refresh: () => { return http.get('auth/partner/refresh/' + new Date().getTime()); },
  setAuth: (token) => { http.defaults.headers.common['Authorization'] = 'Bearer ' + token; },
  unsetAuth: () => { delete http.defaults.headers.common['Authorization']; },

  // check otp
  preflight: (m) => { return http.post('auth/partner/preflight', m); },

  // profile updte
  update: (m) => { return http.post('auth/partner/profile/update', m); },
  ResetPassword : (m) => { return http.post('auth/partner/reset/password', m); },

  // otp
  otpGen : (m) => { return http.post('auth/partner/otp/gen',m); },
  otpVerify : (m) => { return http.post('auth/partner/otp/verify', m); },
  otpRegister : (m) => { return http.post('auth/partner/otp/register', m); },
  otpUnregister : (m) => { return http.post('auth/partner/otp/unregister', m); },

  // token
  tokenReset : (m) => { return http.post('auth/partner/reset/token', m); },
  tokenVerify : (m) => { return http.post('auth/partner/reset/verify', m); },

}
const Billing = (m) => { return http.post(`/billing`, m); }
const Partner = (m) => { return http.post(`/partner`, m); }
const Partner_Call = (a, b, c) => Partner({ target: a, cmd : b, body: c });
const Billing_Call = (a, b, c) => Billing({ target: a, cmd : b, body: c });

export { auth, Partner, Partner_Call, Billing, Billing_Call }
